import { EvaluationsState } from '@/store/evaluations/types';

const state: EvaluationsState = {
  evaluations: [],
  pager: {
    current: 1,
    last: 1,
    totalLength: 0,
  },
};

export default state;
